<template>

  <Row v-if="ready">
    <Column :width="15" class="w3-center">
      <Box>
        <Row>
          <Column :width="10">
            <Box borderStyle="rc-border-thin">
              <Row>
                <Column>
                  {{ file ? file.name : "No file selected" }}
                </Column>
              </Row>
            </Box>
          </Column>
          <Column :width="5">
            <Button v-on:click="$refs.getFile.click()">Select</Button>
            <input type="file" id="getFile" ref="getFile" v-on:change="handleFileUpload" style="display:none" />
          </Column>
        </Row>
      </Box>
    </Column>
  </Row>

</template>

<script>

import { mapGetters } from 'vuex'

import ContentUtils from '@/utils/ContentUtils.js';
import MC from "@/domain/session/MC.js";
import FileUploadDisplayRow from "./FileUploadDisplayRow.js";
import Box from '@/portals/shared/library/box/Box.vue';
import Row from '@/portals/shared/library/box/Row.vue';
import Column from '@/portals/shared/library/box/Column.vue';

export default {
  name: 'file-upload-display-cell',
  components: {
    Box, Row, Column,
  },
  props: {
    data: null,
  },
  data() {
    return {
      ready: false,
      rowData: new FileUploadDisplayRow(),
      Contents: ContentUtils,
      MC: new MC(),

      file: null,
      fileData: null,
      loading: false,
      kvp: {},
    }
  },
  computed: {
    ...mapGetters([
      'domain',
    ]),
    row: function () {
      return this.rowData;
    },
  },
  mounted: function () {
    this.rowData.data = this.data;
    this.ready = true;
  },
  methods: {
    log() {
      return this.domain.logger();
    },  
    withValue: function (kvp) {
      if (kvp) {
        kvp['id'] = this.rowData.id();
        kvp['object'] = this.rowData.object();
        kvp['field'] = this.rowData.field();
        kvp['key'] = this.rowData.key();
        this.log().info("File Upload component {0}", [JSON.stringify(kvp, null, 2)]);
        this.$emit('withValue', kvp);
      }
    },
    handleFileUpload(e) {
      var files = e.target.files || e.dataTransfer.files;
      if (!files.length) {
        return;
      }
      this.file = files[0];
      this.kvp["fileName"] = this.file.name;
      this.kvp["fileSize"] = this.file.size;
      this.kvp["fileType"] = this.file.type;

      const vm = this;
      var reader = new FileReader();
      reader.onloadend = function () {
        var base64data = reader.result;
        vm.kvp["fileData"] = base64data;
        vm.withValue(vm.kvp); 
      }
      reader.readAsDataURL(this.file);
      window.console.log("File: ", this.file);
      this.loading = false;
    },
    handleSelectAction() {
      this.loading = true;
      let ref = this.$refs.getFile;
      ref.click();
      setTimeout(() => {
        this.loading = false;
      }, 1000);
    },
  },
}
</script>